import _forEach from 'lodash/forEach';
import Config from '$root/Config';

import BinCollection from '$collections/bin/BinCollection';
import GarbageBinMarkerCollection from '$collections/GarbageBinMarkerCollection';
import BinMarkerSmallCollection from '$collections/BinMarkerSmallCollection';
import BinAnalyseCollection from '$collections/BinAnalyseCollection';
import GarbageBinSmallCollection from '$collections/GarbageBinSmallCollection';
import ReportBinsCollection from '$collections/ReportBinsCollection';
import ReportBinsMeasurementsCollection from '$collections/ReportBinsMeasurementsCollection';
import ReportBinsMeasurementsLocationCollection from '$collections/ReportBinsMeasurementsLocationCollection';
import MeasuringPeriodCollection from '../../collections/bin/MeasuringPeriodCollection';

import MeasurementCollection from '$collections/measurement/MeasurementCollection';
import TaxonomyCollection from '../../collections/TaxonomyCollection';

export default {
	namespaced: true,

	state() {
		const c_binLocationTypes = new TaxonomyCollection({
			type: 'c_binLocationTypes'
		});
		const c_binMaterials = new TaxonomyCollection({
			type: 'c_binMaterials'
		});
		const c_binSurfaces = new TaxonomyCollection({
			type: 'c_binSurfaces'
		});
		const c_binTypes = new TaxonomyCollection({
			type: 'c_binTypes'
		});
		const c_binDamageAmounts = new TaxonomyCollection({
			type: 'c_binDamageAmounts'
		});
		const c_binDamageTypes = new TaxonomyCollection({
			type: 'c_binDamageTypes'
		});
		const c_binRemarkStatuses = new TaxonomyCollection({
			type: 'c_binRemarkStatuses'
		});
		const c_binActions = new TaxonomyCollection({
			type: 'c_binActions'
		});
		const c_binColors = new TaxonomyCollection({
			type: 'c_binColors'
		});
		const c_binEmptyingFrequencies = new TaxonomyCollection({
			type: 'c_binEmptyingFrequencies'
		});
		const additionalDumpStatuses = new TaxonomyCollection({
			type: 'additionalDumpStatuses'
		});

		return {
			binList: new BinCollection(),

			binMarkers: new GarbageBinMarkerCollection({
				config: { url: Config.getUrl('binMarkers') },
			}),

			binMarkersSmall: new BinMarkerSmallCollection({
				config: { url: Config.getUrl('binsGeoJson'), params: { format: 'geojson' } },
			}),

			binsSmall: new GarbageBinSmallCollection({
				config: { url: Config.getUrl('binsGeoJson'), params: { count: 'all', format: 'geojson' } },
			}),

			simpleBins: new GarbageBinMarkerCollection({
				config: { url: Config.getUrl('binMarkers') },
			}),

			// Pro taxonomies (old JSON:API keys alias the same instances)
			c_binLocationTypes,
			c_binMaterials,
			c_binSurfaces,
			c_binTypes,
			c_binDamageAmounts,
			c_binDamageTypes,
			c_binRemarkStatuses,
			c_binActions,
			c_binColors,
			c_binEmptyingFrequencies,
			colors: c_binColors,
			emptyingFrequencies: c_binEmptyingFrequencies,
			binTypes: c_binTypes,
			binActions: c_binActions,
			binRemarkStatuses: c_binRemarkStatuses,
			locationTypes: c_binLocationTypes,
			surfaces: c_binSurfaces,
			materials: c_binMaterials,

			measurementDamageOptions: c_binDamageAmounts,
			measurementDamageTypeOptions: c_binDamageTypes,

			measurements: new MeasurementCollection({
				config: { url: Config.getUrl('measurements') },
			}),

			measurementAdditionOptions: additionalDumpStatuses,

			analyse: new BinAnalyseCollection({
				config: { url: Config.getUrl('binAnalyse') },
			}),

			reportBins: new ReportBinsCollection({
				config: { url: Config.getUrl('reportBins') },
			}),

			reportMeasurementBins: new ReportBinsMeasurementsCollection({
				config: { url: Config.getUrl('dataBins') },
			}),

			reportMeasurementLocationBins: new ReportBinsMeasurementsLocationCollection({
				config: { url: Config.getUrl('dataBinsLocation') },
			}),

			additionalDumpStatuses,

			dumpStatuses: new TaxonomyCollection({
				type: 'dumpStatuses'
			}),

			fillDegrees: new TaxonomyCollection({
				type: 'fillDegrees'
			}),

			litterStatuses: new TaxonomyCollection({
				type: 'litterStatuses'
			}),

			groups: new TaxonomyCollection({
				type: 'binGroups'
			}),

			measuringPeriods: new MeasuringPeriodCollection({
				config: { url: Config.getUrl('measuringPeriods') },
			}),
		};
	},

	mutations: {
		UPDATE_AUTH(state, payload) {
			const authorizationToken = { Authorization: payload.jwt_authorization };

			// update jwt
			_forEach(state, (item) => {
				item.setConfig('headers', authorizationToken);
			});
		},

		ON_LOGOUT(state) {
			const cleared = new Set();
			_forEach(state, (item) => {
				if (cleared.has(item)) return;
				cleared.add(item);
				item.unsetConfig('headers').clear();
			});
		},
	},
};
